"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.number.constructor");
var _axios = _interopRequireDefault(require("axios"));
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    var _this = this;
    var validateMenuName = function validateMenuName(rule, value, callback) {
      if ((0, _validate.validRule1)(value)) {
        callback(new Error(_this.$t('menuList.error.menuName')));
      } else if (_this.errorKeys.indexOf('menuName') >= 0) {
        callback(new Error(_this.errorInfo['menuName']));
        _this.resetError('menuName');
      } else {
        callback();
      }
    };
    var validateMenuCode = function validateMenuCode(rule, value, callback) {
      if ((0, _validate.validRule3)(value)) {
        callback(new Error(_this.$t('menuList.error.menuCode')));
      } else if (_this.errorKeys.indexOf('menuCode') >= 0) {
        callback(new Error(_this.errorInfo['menuCode']));
        _this.resetError('menuCode');
      } else {
        callback();
      }
    };
    var validateMenuUrl = function validateMenuUrl(rule, value, callback) {
      if ((0, _validate.validRule2)(value)) {
        callback(new Error(_this.$t('menuList.error.menuUrl')));
      } else if (_this.errorKeys.indexOf('menuUrl') >= 0) {
        callback(new Error(_this.errorInfo['menuUrl']));
        _this.resetError('menuUrl');
      } else {
        callback();
      }
    };
    var validateMenuIcon = function validateMenuIcon(rule, value, callback) {
      if ((0, _validate.validRule3)(value)) {
        callback(new Error(_this.$t('menuList.error.menuIcon')));
      } else if (_this.errorKeys.indexOf('menuIcon') >= 0) {
        callback(new Error(_this.errorInfo['menuIcon']));
        _this.resetError('menuIcon');
      } else {
        callback();
      }
    };
    var validateComponent = function validateComponent(rule, value, callback) {
      if ((0, _validate.validRule2)(value)) {
        callback(new Error(_this.$t('menuList.error.component')));
      } else if (_this.errorKeys.indexOf('component') >= 0) {
        callback(new Error(_this.errorInfo['component']));
        _this.resetError('component');
      } else {
        callback();
      }
    };
    var validateRemark = function validateRemark(rule, value, callback) {
      if (!value) {
        callback();
      }
      if ((0, _validate.validRule1)(value)) {
        callback(new Error(_this.$t('menuList.error.remark')));
      } else if (_this.errorKeys.indexOf('remark') >= 0) {
        callback(new Error(_this.errorInfo['remark']));
        _this.resetError('remark');
      } else {
        callback();
      }
    };
    var validateSn = function validateSn(rule, value, callback) {
      value = Number(value);
      if (typeof value === 'number' && !isNaN(value)) {
        callback();
      } else {
        callback(new Error(_this.$t('menuList.error.sn')));
      }
    };
    return {
      pageName: 'menulist',
      formLabelWidth: '120px',
      loadingComponent: null,
      listLoading: false,
      isLoading: false,
      list: [],
      total: 0,
      currentId: null,
      isShowModel: false,
      currPage: 1,
      limit: 10,
      sourceApi: null,
      dialogStatus: 'create',
      form: {
        menuPk: '',
        parentMenuPk: '',
        parentMenuName: '',
        menuName: '',
        menuCode: '',
        menuUrl: '',
        menuIcon: '',
        component: '',
        isTop: '',
        isVirtual: '',
        sn: '',
        remark: ''
      },
      initForm: {
        menuPk: '',
        parentMenuPk: '',
        parentMenuName: '',
        menuName: '',
        menuCode: '',
        menuUrl: '',
        menuIcon: '',
        component: '',
        isTop: '',
        isVirtual: '',
        sn: '',
        remark: ''
      },
      rules: {
        menuName: [{
          required: true,
          trigger: ['change'],
          validator: validateMenuName
        }],
        menuCode: [{
          required: true,
          trigger: ['change'],
          validator: validateMenuCode
        }],
        menuUrl: [{
          required: true,
          trigger: ['change'],
          validator: validateMenuUrl
        }],
        menuIcon: [{
          required: true,
          trigger: ['change'],
          validator: validateMenuIcon
        }],
        component: [{
          required: true,
          trigger: ['change'],
          validator: validateComponent
        }],
        remark: [{
          required: false,
          trigger: ['change'],
          validator: validateRemark
        }],
        sn: [{
          required: false,
          trigger: ['change'],
          validator: validateSn
        }]
      },
      errorKeys: [],
      errorInfo: {}
    };
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    }
  },
  mounted: function mounted() {
    this.fetchData();
  },
  methods: {
    resetError: function resetError(val) {
      if (val) {
        var index = this.errorKeys.indexOf(val);
        this.errorKeys.splice(index, 1);
        delete this.errorInfo.val;
      } else {
        this.errorKeys = [];
        this.errorInfo = {};
      }
    },
    tableIndex: function tableIndex(index) {
      return index + 1;
    },
    isTopFormatter: function isTopFormatter(row, column, cellValue) {
      return cellValue === 'Y' ? '是' : '否';
    },
    isVirtualFormatter: function isVirtualFormatter(row, column, cellValue) {
      var options = {
        'N': '菜单',
        'R': '路由菜单',
        'V': '虚拟菜单'
      };
      return options[cellValue];
    },
    fetchData: function fetchData() {
      var _this2 = this;
      this.listLoading = true;
      this.$api.menu.getMenuList({}).then(function (res) {
        _this2.listLoading = false;
        _this2.list = res.data;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this2.listLoading = false;
      });
    },
    refreshData: function refreshData() {
      this.fetchData();
    },
    create: function create(row) {
      var _this3 = this;
      this.dialogStatus = 'create';
      var parentMenuPk = '';
      var parentMenuName = '';
      if (row) {
        parentMenuPk = row.menuPk;
        parentMenuName = row.menuName;
      }
      this.form = {
        menuPk: '',
        parentMenuPk: parentMenuPk,
        parentMenuName: parentMenuName,
        menuName: '',
        menuCode: '',
        menuUrl: '',
        menuIcon: '',
        component: '',
        isTop: 'Y',
        isVirtual: 'N',
        sn: '',
        remark: ''
      };
      this.initForm = {
        menuPk: '',
        parentMenuPk: parentMenuPk,
        parentMenuName: parentMenuName,
        menuName: '',
        menuCode: '',
        menuUrl: '',
        menuIcon: '',
        component: '',
        isTop: 'Y',
        isVirtual: 'N',
        sn: '',
        remark: ''
      };
      this.isShowModel = true;
      this.$nextTick(function () {
        _this3.$refs['dataForm'].clearValidate();
      });
    },
    edit: function edit(row) {
      var _this4 = this;
      this.dialogStatus = 'edit';
      this.currentId = row.menuPk;
      this.isShowModel = true;
      if (this.currentId === null) {
        return;
      }
      this.getDetail().then(function (res) {
        _this4.isShowModel = true;
        _this4.$nextTick(function () {
          _this4.$refs['dataForm'].clearValidate();
        });
      });
    },
    getDetail: function getDetail() {
      var _this5 = this;
      return new Promise(function (resolve) {
        _this5.isLoading = true;
        _this5.$api.menu.getMenuDetail(_this5.currentId).then(function (res) {
          _this5.isLoading = false;
          var _res$data = res.data,
            menuPk = _res$data.menuPk,
            parentMenuPk = _res$data.parentMenuPk,
            parentMenuName = _res$data.parentMenuName,
            menuName = _res$data.menuName,
            menuCode = _res$data.menuCode,
            menuUrl = _res$data.menuUrl,
            menuIcon = _res$data.menuIcon,
            component = _res$data.component,
            isTop = _res$data.isTop,
            isVirtual = _res$data.isVirtual,
            sn = _res$data.sn,
            remark = _res$data.remark;
          _this5.form = {
            menuPk: menuPk,
            parentMenuPk: parentMenuPk,
            parentMenuName: parentMenuName,
            menuName: menuName,
            menuCode: menuCode,
            menuUrl: menuUrl,
            menuIcon: menuIcon,
            component: component,
            isTop: isTop,
            isVirtual: isVirtual,
            sn: sn,
            remark: remark
          };
          _this5.initForm = {
            menuPk: menuPk,
            parentMenuPk: parentMenuPk,
            parentMenuName: parentMenuName,
            menuName: menuName,
            menuCode: menuCode,
            menuUrl: menuUrl,
            menuIcon: menuIcon,
            component: component,
            isTop: isTop,
            isVirtual: isVirtual,
            sn: sn,
            remark: remark
          };
          resolve(_this5.form);
        }).catch(function () {
          _this5.isLoading = false;
          console.log('Data Request Fail');
        });
      });
    },
    deleteItem: function deleteItem(row) {
      var _this6 = this;
      this.$confirm(this.$t('common.confirm1'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(function () {
        _this6.isLoading = true;
        _this6.$api.menu.deleteMenu([row.menuPk]).then(function (res) {
          _this6.isLoading = false;
          _this6.refreshData();
        }).catch(function () {
          _this6.isLoading = false;
        });
      }).catch(function () {});
    },
    saveItem: function saveItem() {
      var _this7 = this;
      this.$refs['dataForm'].clearValidate();
      this.$refs.dataForm.validate(function (valid) {
        if (!valid) return;
        _this7.isLoading = true;
        _this7.$api.menu.saveMenu(_this7.form).then(function (res) {
          _this7.isLoading = false;
          _this7.isShowModel = false;
          _this7.refreshData();
        }).catch(function (err) {
          if (err.errorInfos && err.errorInfos.length > 0) {
            _this7.resetError();
            err.errorInfos.forEach(function (item) {
              _this7.errorKeys.push(item.key);
              _this7.errorInfo[item.key] = item.errMsg;
            });
            _this7.$refs['dataForm'].validate(function (valid) {
              console.log(valid);
            });
          }
          _this7.isLoading = false;
          // this.$message.error('保存失败')
        });
      });
    },
    disableMenu: function disableMenu(row) {
      var _this8 = this;
      this.$confirm(this.$t('common.confirm2'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(function () {
        _this8.$api.menu.disableMenu([row.menuPk]).then(function (res) {
          _this8.$message.success(_this8.$t('common.disabledSuccess'));
          _this8.refreshData();
        }).catch(function () {
          // this.$message.error('禁用失败')
        });
      }).catch(function () {});
    },
    enableMenu: function enableMenu(row) {
      var _this9 = this;
      this.$confirm(this.$t('common.confirm3'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(function () {
        _this9.$api.menu.enableMenu([row.menuPk]).then(function (res) {
          _this9.$message.success(_this9.$t('common.enableSuccess'));
          _this9.refreshData();
        }).catch(function () {
          // this.$message.error('启用失败')
        });
      }).catch(function () {});
    },
    deleteMenu: function deleteMenu(row) {
      var _this0 = this;
      this.$confirm(this.$t('common.confirm4'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(function () {
        _this0.$api.menu.deleteMenu([row.menuPk]).then(function (res) {
          _this0.$message.success(_this0.$t('common.deleteSuccess'));
          _this0.refreshData();
        }).catch(function () {
          // this.$message.error('删除失败')
        });
      }).catch(function () {});
    }
  }
};